import { Text, SVG } from "sunrise-ui";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import "./List.scss";
import dateFormat from "../../utilities/dateFormat";
import EnlargeImage from "../Users/EnlargeImage";
import NoDataScreen from "../../utilities/NoDataScreen";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import { CSVLink } from "react-csv";

export const useStylesForTable = makeStyles({
  table: {
    width: "max-content",
    minWidth: "40rem",
  },
});

export const useStylesForSmallTable = makeStyles({
  table: {
    minWidth: 650,
  },
});

const getDeepValue = function (data: any, path: string) {
  for (let i = 0, key = path.split("."), len = key.length; i < len; i++) {
    data = data[key[i]] ? data[key[i]] : "";
  }
  return data;
};

const List = (prop: any) => {
  const { listData, fields, title, nodataText, dataToDownLoad } = prop;
  // ---------------for enlarge image modal-------------
  const [modalData, setModalData] = React.useState({
    image: "",
    isOpen: false,
  });
  const handleOpen = (photo: string) => {
    setModalData({ ...modalData, image: photo, isOpen: true });
  };

  React.useEffect(() => {
    setRows(listData);
    if (page > Math.floor(listData.length / rowsPerPage) - 1) {
      setPage(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listData]);

  const [rows, setRows] = React.useState<any>(listData);
  const tableClasses = useStylesForTable();
  const tableClassesSmall = useStylesForSmallTable();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [isData, setIsData] = React.useState(false);
  const [isProjectSelect, setIsprojectSelect] = React.useState(false);

  const [searchVal, setSearchVal] = React.useState([]);
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    setRows(listData);
    if (listData.length > 0) setIsData(true);
    else setIsData(false);
  }, [listData]);

  useEffect(() => {
    prop?.project === "" ? setIsprojectSelect(true) : setIsprojectSelect(false);
    // eslint-disable-next-line
  }, [prop?.project]);

  const filterData = (e: any) => {
    if (e.target.value !== "") {
      setSearchVal(e.target.value);
      const filterTable = listData.filter((item: any) => {
        for (let i = 0; i < fields?.length; i++) {
          if (fields[i]?.value && fields[i]?.search) {
            const deepValue = getDeepValue(item, fields[i].value);
            if (
              typeof deepValue === "string" &&
              deepValue?.toLowerCase()?.includes(e.target.value.toLowerCase())
            ) {
              return true;
            } else if (
              deepValue
                ?.toString()
                ?.toLowerCase()
                ?.includes(e.target.value.toLowerCase())
            ) {
              return true;
            }
          }
        }
        return false;
      });
      if (page > Math.floor(filterTable.length / rowsPerPage) - 1) {
        setPage(0);
      }
      setRows(filterTable);
    } else {
      setSearchVal(e.target.value);
      setRows(listData);
    }
  };

  const displayValue = (row: any, field: string, format?: string) => {
    if (format?.toLocaleLowerCase() === "date") {
      return dateFormat(getDeepValue(row, field)?.split("T")[0]);
    } else if (format?.toLocaleLowerCase() === "image") {
      return (
        <img
          src={getDeepValue(row, field)}
          alt="..."
          className="list-photo pointer"
          onClick={() => {
            handleOpen(getDeepValue(row, field));
          }}
        />
      );
    } else {
      return getDeepValue(row, field);
    }
  };

  return (
    <Grid container className="list_wrapper bg--white box--shadow mt1">
      <Grid item xs={12}>
        <Grid item xs={12}>
          <Grid container className="d-flex v-center sb mt">
            <Grid>
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb0 mt0 p1"
              >
                {title}
              </Text>
            </Grid>

            {isData && (
              <Grid className="d-flex sb v-center relative">
                <div className="searchIcon_box absolute">
                  <SVG type={"searchIcon"} />
                </div>
                <div className="search_box mr-1">
                  <input
                    type="search"
                    id="tableSearch"
                    name="tableSearch"
                    placeholder="Search"
                    value={searchVal}
                    onChange={filterData}
                  />
                </div>
                <CSVLink
                  data={dataToDownLoad ? dataToDownLoad : ""}
                  filename={`${title}.csv`}
                >
                  <SVG type={"download"} isActive={true} />
                </CSVLink>
              </Grid>
            )}
          </Grid>
        </Grid>

        {isData ? (
          <TableContainer>
            <Grid className="list_wrapper__container">
              <Table
                className={
                  prop.sizeType === "large"
                    ? tableClasses.table
                    : tableClassesSmall.table
                }
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    {fields &&
                      fields.map((field: any) => (
                        <TableCell
                          key={`Field_header_${field.header}`}
                          className="f16 fw500"
                          align="left"
                        >
                          {field.header}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                {rows?.length > 0 ? (
                  <TableBody>
                    {rows
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row: any, index: number) => (
                        <TableRow key={`row${index}`}>
                          {fields &&
                            fields.map((field: any, itemIdx: number) => {
                              return (
                                <TableCell
                                  key={`row${index}_item${itemIdx}`}
                                  align="left"
                                  style={field.header==="Action/Status"?{ minWidth: 200 }:{ minWidth: 150 }}
                                  title={
                                    field.header ===
                                      "Undo Request Approve/Rejection reason"
                                      ? row.undoApproveOrRejectReason
                                      :  field.header === "Pile Discarded/Rejected Reason" 
                                      ? row.discaredRejectedReason : ""
                                  }
                                  className={
                                    field.header ===
                                      "Undo Request Approve/Rejection reason" ||
                                      "Pile Discarded/Rejected Reason" 
                                      ? "pl0 mt0 mb0 fw400 truncate"
                                      : "pl0 mt0 mb0 fw400"
                                  }
                                >
                                  <Text
                                    fonts="normal"
                                    type="normal"
                                    className="pl mt0 mb0 fw400"
                                    fontSize={14}
                                  > 
                                    {field.value &&
                                      !field.action &&
                                      displayValue(
                                        row,
                                        field.value,
                                        field.format
                                      )}
                                    {field.action && field.action(row)}
                                  </Text>
                                </TableCell>
                              );
                            })}
                        </TableRow>
                      ))}
                  </TableBody>
                ) : (
                  <TableRow>
                    <TableCell colSpan={13} align="center">
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </Table>
            </Grid>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={rows?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        ) : (
          !isProjectSelect && <NoDataScreen text={nodataText} className="mb1" />
        )}
        {isProjectSelect && (
          <SelectOptionMsg text="Select project to get project details." />
        )}
      </Grid>
      {/* ---------------Enlarge Image Modal---------- */}
      <EnlargeImage modalData={modalData} />
    </Grid>
  );
};

export default List;
